"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeAndRemoveDuplicates = void 0;
const lodash_assignwith_1 = __importDefault(require("lodash.assignwith"));
const lodash_uniqby_1 = __importDefault(require("lodash.uniqby"));
const customizer = (newVal, srcVal, key) => {
    if (srcVal === undefined || srcVal === null) {
        return newVal;
    }
    if (newVal && (key === 'home' || key === 'auto' || key === 'global')) {
        return Object.assign(newVal, srcVal);
    }
};
function mergeAndRemoveDuplicates(policyDetailsIn, segment) {
    const policyDetails = policyDetailsIn;
    (0, lodash_assignwith_1.default)(policyDetails, segment, customizer);
    // now remove duplicates from the arrays where things could have been removed:
    if (policyDetails.cars) {
        policyDetails.cars = (0, lodash_uniqby_1.default)(policyDetails.cars, 'VIN');
    }
    if (policyDetails.drivers) {
        policyDetails.drivers = (0, lodash_uniqby_1.default)(policyDetails.drivers, 'id');
    }
    if (policyDetails.people) {
        policyDetails.people = (0, lodash_uniqby_1.default)(policyDetails.people, 'id');
    }
    if (policyDetails.trailers) {
        policyDetails.trailers = (0, lodash_uniqby_1.default)(policyDetails.trailers, 'VIN');
    }
    if (segment.scheduledPersonalProperty &&
        segment.scheduledPersonalProperty.items &&
        !segment.scheduledPersonalProperty.items.length) {
        policyDetails.scheduledPersonalProperty.items = [];
    }
    return policyDetails;
}
exports.mergeAndRemoveDuplicates = mergeAndRemoveDuplicates;
//# sourceMappingURL=merge.js.map